import { PaginateResult } from "core/resources/types/shared";
import { useQuery } from "react-query";
import axios from "infra/http";
import { UnidadeSimplesPaginateResponse, UnidadesPaginateQuery } from "./typings/unidade";

function useUnidadesSimplificado(tenantId?: string, params?: UnidadesPaginateQuery, enabled: boolean = true) {
  return useQuery(
    [`/v1/unidades/simples`, tenantId, params],
    async () => {
      const res = await axios.get<PaginateResult<UnidadeSimplesPaginateResponse>>(
        `/v1/unidades/simples`,
        {
          params: {
            page: 1,
            limit: 20,
            tenantId,
            ...(params ?? {}),
          },
        }
      );

      return res.data;
    },
    {enabled}
  );
}

export default useUnidadesSimplificado;
